import { useState } from 'react';
import { Flag } from 'lucide-react';

import { Button } from '@components/ui/button';
import { isProdApp } from '@shared-web/constants/env';

import { Devtool } from '../Devtool';
import { Logo } from './Logo';

export interface HeaderManagerProps {
  /** Optional className for custom styling */
  readonly className?: string;
}

/**
 * HeaderManager Component for Webview
 *
 * Simple header with:
 * - Logo (links to home)
 * - Flag button (opens Devtool, non-prod only)
 *
 * This is a simplified version of the web HeaderManager,
 * designed for mobile webview use cases.
 */
export function HeaderManager({ className }: HeaderManagerProps) {
  const [isShowDevtool, setIsShowDevtool] = useState(false);

  return (
    <>
      {isShowDevtool && <Devtool onClose={() => setIsShowDevtool(false)} />}
      <header
        className={`bg-background border-border flex h-14 w-full shrink-0 items-center justify-between border-b px-4 ${className ?? ''}`}
      >
        {/* Left: Logo + Flag */}
        <div className="flex items-center gap-2">
          <Logo />
          {!isProdApp && (
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsShowDevtool((prev) => !prev)}
              aria-label="Toggle Devtool"
            >
              <Flag className="text-warning size-4" />
            </Button>
          )}
        </div>
      </header>
    </>
  );
}
